import Vue from 'vue'
let eventHub = new Vue()
export default eventHub



// WEBPACK FOOTER //
// ./src/store/event_hub.js